module.exports = __webpack_public_path__ + "static/media/video-call-icon.451fd11c.png";